export default __webpack_public_path__ + "b949505.png";